import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useGearData } from "@/lib/gear";
import { BuildsList } from "@/components/builds/BuildsList";
import { BuildEditor } from "@/components/builds/BuildEditor";
import { AssetsTab } from "@/components/builds/AssetsTab";
import { CorrectionsTab } from "@/components/builds/CorrectionsTab";

export const BuildsPanel = ({ open, onClose, me }) => {
  const { catalog, assets } = useGearData();
  const [tab, setTab] = useState("builds");
  const [builds, setBuilds] = useState(null);
  const [sel, setSel] = useState(null);
  const [dirty, setDirty] = useState(false);
  const pick = (id) => { if (dirty && id !== sel && !window.confirm("You have unsaved changes. Leave this hero without saving?")) return; setSel(id); };
  const load = () => api.get("/builds").then((r) => setBuilds(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { if (open) load(); }, [open]);
  if (!open) return null;
  const b = builds && builds.find((x) => x.id === sel);

  return (
    <div className="lg lg-builds" data-testid="builds-panel">
      <div className="lg-builds-head">
        <h2 style={{ margin: 0, fontSize: 22, marginRight: 16 }}>Gear builds</h2>
        <div className="lg-seg">
          {[["builds", "Builds"], ["maker", "Card maker"], ["assets", "Asset library"], ["corrections", "Corrections"]].map(([k, l]) => (
            <button key={k} className={tab === k ? "on" : ""} onClick={() => setTab(k)} data-testid={`builds-tab-${k}`}>{l}</button>))}
        </div>
        <button className="lg-btn ghost sm" style={{ marginLeft: "auto" }} onClick={onClose} data-testid="builds-close"><X size={14} /></button>
      </div>
      {(!catalog || !builds) && <p style={{ padding: 20 }}>Loading…</p>}
      {catalog && builds && tab === "builds" && (
        <div className="lg-builds-body">
          <BuildsList builds={builds} selId={sel} onSelect={pick} onChanged={load} />
          <div className="lg-builds-main">
            {b ? <BuildEditor b={b} catalog={catalog} assets={assets} me={me} onSaved={load} onDirty={setDirty} />
              : <p style={{ color: "var(--muted)" }} data-testid="builds-empty">{builds.length ? "Pick a hero on the left to review and edit their builds." : "No builds yet. Press \"Make drafts for every hero\" to start from the foundation rules."}</p>}
          </div>
        </div>
      )}
      {tab === "maker" && <iframe className="lg-maker" src="/legion/gear/maker.html" title="Gear card maker" data-testid="card-maker-frame" />}
      {tab === "assets" && <div className="lg-builds-pad"><AssetsTab /></div>}
      {tab === "corrections" && <div className="lg-builds-pad"><CorrectionsTab /></div>}
    </div>
  );
};
